export const API_BASE_URL = process.env.VUE_APP_API_BASE_URL;
export const DJANGO_ADMIN_URL = process.env.VUE_APP_DJANGO_ADMIN_URL;